<template>
  <div>
    <load-profile></load-profile>
    <!-- Search Container Card -->
    <n-search-container @search="search" @reset="reset" :fields="searchFields">
      <n-search-input ref="search" :fields="searchFields" v-model="params">
        <template #departmentId="item">
          <b-form-group :label-for="item.field.key">
            <label>
              {{ $t(item.field.label) }}
            </label>
            <n-async-single-select
              v-model="params[item.field.key]"
              :query="
                params.companyId
                  ? [
                      {
                        searchby: 'company_id',
                        searchoperator: '=',
                        search: params.companyId,
                      },
                    ]
                  : []
              "
              :ref="item.field.key"
              :name="item.field.key"
              :repository="item.field.repository"
              :selection-key="item.field.selectionKey"
              :selection-label="item.field.selectionLabel"
            ></n-async-single-select>
          </b-form-group>
        </template>
      </n-search-input>
    </n-search-container>

    <!-- Table Container Card -->
    <b-card no-body class="mb-0">
      <div class="m-1">
        <b-row>
          <b-col>
            <label>{{ $t("general.entries") }}</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block ml-50 mr-1"
            />
          </b-col>
          <b-col class="text-right">
            <b-button
              variant="primary"
              :to="{ name: `create-${permissionType}` }"
              >{{ $t("button.create") }}</b-button
            >
          </b-col>
        </b-row>
      </div>
      <div>
        <n-view-table
          :fields="viewTableFields"
          :type="permissionType"
          ref="viewTable"
        >
          <template #cell(status)="data">
            <b-badge
              pill
              variant="success"
              badge-glow
              v-if="data.item.isEnable"
            >
              {{ $t(`status.active`) }}
            </b-badge>
            <b-badge pill variant="danger" badge-glow v-else>
              {{ $t(`status.inactive`) }}
            </b-badge>
          </template>
          <template #cell(company)="data">
            <b-link
              class="link-underline"
              :to="{
                name: 'view-company',
                params: { id: data.item.company.id },
              }"
              v-if="data.item.company"
            >
              {{ data.item.company.name }}
            </b-link>
          </template>
          <template #cell(department)="data">
            <b-link
              class="link-underline"
              :to="{
                name: 'view-department',
                params: { id: data.item.department.id },
              }"
              v-if="data.item.department"
            >
              {{ data.item.department.name }}
            </b-link>
          </template>
          <template #cell(manager)="data">
            <b-link
              class="link-underline"
              :to="{
                name: 'view-employee',
                params: { id: data.item.manager.id },
              }"
              v-if="data.item.manager"
            >
              {{ data.item.manager.name }}
            </b-link>
          </template>
          <template #cell(position)="data">
            <b-link
              class="link-underline"
              :to="{
                name: 'view-position',
                params: { id: data.item.position.id },
              }"
              v-if="data.item.position"
            >
              {{ data.item.position.name }}
            </b-link>
          </template>
          <template #cell(lastActivityAt)="data">
            {{ data.item.lastActivityAt | formatDate }}
          </template>
        </n-view-table>
        <n-table
          @sort-changed="sortChanged"
          :fields="fields"
          :items="items"
          :busy="loading"
          :current-page="params.page"
          :per-page="$store.state.pagination.perPage"
          :total="total"
          :type="permissionType"
          :view-modal="true"
          @view="view"
        >
          <template #cell(status)="data">
            <b-badge
              pill
              variant="success"
              badge-glow
              v-if="data.item.isEnable"
            >
              {{ $t(`status.active`) }}
            </b-badge>
            <b-badge pill variant="danger" badge-glow v-else>
              {{ $t(`status.inactive`) }}
            </b-badge>
          </template>
          <template #cell(company)="data">
            <b-link
              class="link-underline"
              :to="{
                name: 'view-company',
                params: { id: data.item.company.id },
              }"
              v-if="data.item.company"
            >
              {{ data.item.company.name }}
            </b-link>
          </template>
          <template #cell(department)="data">
            <b-link
              class="link-underline"
              :to="{
                name: 'view-department',
                params: { id: data.item.department.id },
              }"
              v-if="data.item.department"
            >
              {{ data.item.department.name }}
            </b-link>
          </template>
          <template #cell(manager)="data">
            <b-link
              class="link-underline"
              :to="{
                name: 'view-employee',
                params: { id: data.item.manager.id },
              }"
              v-if="data.item.manager"
            >
              {{ data.item.manager.name }}
            </b-link>
          </template>
          <template #cell(position)="data">
            <b-link
              class="link-underline"
              :to="{
                name: 'view-position',
                params: { id: data.item.position.id },
              }"
              v-if="data.item.position"
            >
              {{ data.item.position.name }}
            </b-link>
          </template>
          <template #cell(lastActivityAt)="data">
            {{ data.item.lastActivityAt | formatDate }}
          </template>
        </n-table>
        <n-pagination
          ref="pagination"
          class="mt-2"
          :total="total"
          :per-page="$store.state.pagination.perPage"
          :page="params.page"
          @change="list"
        ></n-pagination>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BFormGroup,
  BInputGroup,
  BAvatar,
  BBadge,
  BLink,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Repository from "@/repositories/RepositoryFactory";
import NPagination from "@/components/NPagination";
import NSearchContainer from "@/components/NSearchContainer";
import NSearchInput from "@/components/NSearchInput";
import NButtonDelete from "@/components/NButtonDelete";
import NTable from "@/components/NTable";
import NViewTable from "@/components/NViewTable";
import TableFields from "./tableFields";
import ViewTableFields from "./viewTableFields";
import SearchInputs from "./searchInput";
import NAsyncSingleSelect from "@/components/NAsyncSingleSelect";

const StockAdminRepository = Repository.get("stockAdmin");

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BAvatar,
    NPagination,
    NSearchContainer,
    NSearchInput,
    NButtonDelete,
    NTable,
    NViewTable,
    vSelect,
    NAsyncSingleSelect,
    BFormGroup,
    BInputGroup,
    BBadge,
    BLink,
  },
  watch: {
    perPage(value) {
      this.list(1);
    },
  },
  computed: {
    perPage: {
      get() {
        return this.$store.state.pagination.perPage;
      },
      set(value) {
        this.$store.commit("pagination/SET_PER_PAGE", value);
      },
    },
  },
  data() {
    return {
      items: [],
      loading: false,
      total: 0,
      perPageOptions: this.$store.state.pagination.perPageOptions,
      params: {
        page: Number(this.$route.query.page) || 1,
        order: this.$route.query.order || null,
        sort: this.$route.query.sort || null,
        companyId: Number(this.$route.query.companyId) || null,
        departmentId: Number(this.$route.query.departmentId) || null,
        positionId: Number(this.$route.query.positionId) || null,
        idCard: this.$route.query.idCard || null,
        name: this.$route.query.name || null,
      },
    };
  },
  watch: {
    "params.companyId"(newValue, oldValue) {
      if (oldValue && newValue != oldValue) {
        this.$refs.departmentId.clear();
      }
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    view(item) {
      this.$refs.viewTable.view(item);
    },
    updateQuerySting() {
      this.$router.replace({ query: this.params });
    },
    list(page = 1) {
      this.params.page = page;
      this.updateQuerySting();
      this.getData();
    },
    sortChanged(sortBy, sortDirection) {
      this.params.order = sortBy;
      this.params.sort = sortDirection;
      this.updateQuerySting();
      this.getData();
    },
    search() {
      this.params.page = 1;
      this.$refs.pagination.reset();
      this.updateQuerySting();
      this.getData();
    },
    reset() {
      this.$refs.search.reset();
      this.params.page = 1;
      this.$refs.pagination.reset();
      this.updateQuerySting();
      this.getData();
    },
    getData() {
      this.loading = true;
      const params = {
        ...this.params,
        searchFields: this.searchFields,
      };
      StockAdminRepository.index(params)
        .then((response) => {
          const data = response.data.data;
          this.items = [...data.list];
          this.total = data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
  setup() {
    const fields = TableFields;
    const viewTableFields = ViewTableFields;
    const searchFields = SearchInputs;
    const permissionType = "stock-admin";
    return {
      fields,
      viewTableFields,
      searchFields,
      permissionType,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
